import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { IProcessBoxesProps } from '../components/process-boxes/process-boxes';
import { IProcessBoxProps } from '../components/process-boxes/process-box/process-box';
import { ProcessBoxModel } from './process-box-model';

export class ProcessBoxesModel extends ContentItem {
  get boxes(): IProcessBoxProps[] {
    const nodes = get(this._config, 'elements.boxes.value', []);
    const modeledBoxes = nodes
      ? nodes.map((box: IProcessBox) => ProcessBoxModel.create(box))
      : null;

    return modeledBoxes;
  }

  public static create(data: IProcessBoxes): IProcessBoxesProps {
    const { boxes } = new ProcessBoxesModel(data);
    return {
      boxes
    };
  }
}
